import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/src/js/ui/photoswipe-ui-default';
import trans from './i18n';

export function openPhotoSwipe(...photos) {
  const pswpElement = document.querySelectorAll('.pswp')[0];

  // build items array
  const items = [];
  photos.forEach((photo) =>
    items.push({
      src: photo,
      w: 1920,
      h: 1920,
      caption: /§{2}_/.test(photo) ? trans('js-files.foto-campione') : null,
    })
  );
  console.log(typeof photos, photos);
  console.log(items);

  const options = {
    index: 0, // start at first slide
  };

  // Initializes and opens PhotoSwipe
  const gallery = new PhotoSwipe(
    pswpElement,
    PhotoSwipeUI_Default,
    items,
    options
  );
  gallery.init();
}
